import React from 'react';
import { Link } from 'react-router-dom';
import { Clock } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';

const BlogCardSmall = ({ blog }) => {
  return (
    <Link
      to={`/blogs/${blog.slug || blog._id}`}
      className="group flex flex-col h-full p-3 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors border border-gray-200 dark:border-gray-700 card"
    >
      {/* Small Image */}
      <div className="w-full h-40 md:h-48 rounded overflow-hidden bg-gray-200 dark:bg-gray-700 mb-3 flex-shrink-0">
        <img
          src={blog.thumbnail}
          alt={blog.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          onError={(e) => {
            e.target.src = 'https://via.placeholder.com/200x200?text=Blog';
          }}
        />
      </div>

      {/* Content */}
      <div className="flex-1 flex flex-col">
        <span className="text-xs font-medium text-accent mb-1 block">
          {blog.category}
        </span>
        <h3 className="font-heading font-semibold text-heading dark:text-white mb-2 line-clamp-2 group-hover:text-accent transition-colors text-sm">
          {blog.title}
        </h3>
        {blog.excerpt && (
          <p className="text-xs text-gray-600 dark:text-gray-400 mb-2 line-clamp-2 flex-1">
            {blog.excerpt}
          </p>
        )}
        <div className="flex items-center text-xs text-gray-500 dark:text-gray-500 mt-auto">
          <Clock className="w-3 h-3 mr-1" />
          <span>
            {blog.publishedAt
              ? formatDistanceToNow(new Date(blog.publishedAt), { addSuffix: true })
              : formatDistanceToNow(new Date(blog.createdAt), { addSuffix: true })}
          </span>
        </div>
      </div>
    </Link>
  );
};

export default BlogCardSmall;
